import { FeatureFlags } from '@buy-viasat/types/build/bv';
import { Features } from '@buy-viasat/redux/src/app';

export const transformFeatureFlags = (flags: FeatureFlags): Features => {
  return {
    maintenanceMode: Boolean(flags.maintenanceMode),
    enableFiber: Boolean(flags.enableFiber),
    enableUnleashedMax: Boolean(flags.enableUnleashedMax),
  };
};
